"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuxonDateTimeFormatStringSchema = exports.LuxonDateTimeFormatStringRegex = exports.NonBusinessDayAdjustmentSchema = exports.DaySchema = exports.DayIterable = exports.Reporting = exports.RecurringDate = void 0;
const zod_1 = require("zod");
// Re-export namespaces as modules
exports.RecurringDate = __importStar(require("./Date/RecurringDate"));
exports.Reporting = __importStar(require("./Date/Reporting"));
// Week starts with Monday (1) and ends with Sunday (7).
const WeekdaySchema = zod_1.z.union([
    zod_1.z.literal(1),
    zod_1.z.literal(2),
    zod_1.z.literal(3),
    zod_1.z.literal(4),
    zod_1.z.literal(5),
    zod_1.z.literal(6),
    zod_1.z.literal(7),
]);
exports.DayIterable = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];
exports.DaySchema = zod_1.z.enum(exports.DayIterable);
const DayUnitSchema = zod_1.z.enum(['businessDay', 'calendarDay']);
exports.NonBusinessDayAdjustmentSchema = zod_1.z.enum(['before', 'after']);
exports.LuxonDateTimeFormatStringRegex = /^(?:\s|'.*'|\W)*(?:S|SSS|u|uu|uuu|s|ss|m|mm|h|hh|H|HH|Z|ZZ|ZZZ|ZZZZ|ZZZZZ|z|a|d|dd|c|ccc|cccc|ccccc|L|M|LL|MM|LLL|MMM|LLLL|MMMM|LLLLL|MMMMM|y|yy|yyyy|G|GG|GGGGG|kk|kkkk|W|WW|o|ooo|q|qq|D|DD|DDD|DDDD|t|tt|ttt|tttt|T|TT|TTT|TTTT|f|ff|fff|ffff|F|FF|FFF|FFFF|X|x)+(?:S|SSS|u|uu|uuu|s|ss|m|mm|h|hh|H|HH|Z|ZZ|ZZZ|ZZZZ|ZZZZZ|z|a|d|dd|c|ccc|cccc|ccccc|L|M|LL|MM|LLL|MMM|LLLL|MMMM|LLLLL|MMMMM|y|yy|yyyy|G|GG|GGGGG|kk|kkkk|W|WW|o|ooo|q|qq|D|DD|DDD|DDDD|t|tt|ttt|tttt|T|TT|TTT|TTTT|f|ff|fff|ffff|F|FF|FFF|FFFF|X|x|\s|'.*'|\W)*$/;
/**
 * What's allowed for this input:
 * - any combination of [Luxon's DateTime formating tokens (click me for the full list)](https://moment.github.io/luxon/#/formatting?id=table-of-tokens)
 * - whitespace(s)
 * - any string surrounded by single quotes (e.g. `'hello'-MM-dd-yyyy'world'`)
 * - any non-word character (e.g. `!@#$%^&*()_+-/<>?:"{}[]\|;`)
 */
exports.LuxonDateTimeFormatStringSchema = zod_1.z
    .string()
    .regex(exports.LuxonDateTimeFormatStringRegex);
//# sourceMappingURL=Date.js.map